import React, {useEffect, useRef} from 'react';

export const scrollSelectedItemIntoView = itemRef => {
    if (itemRef?.current && isInvisible(itemRef.current)) {
        // need a delay because of scrollToTop effect in OptionsList component
        setTimeout(() => {
            itemRef?.current?.scrollIntoView?.({block: 'nearest', inline: 'nearest'});
        });
    }
};

const isInvisible = elementRef => {
    const element =
        elementRef.offsetTop === 0 &&
        elementRef.parentElement &&
        elementRef.parentElement.offsetTop !== 0
            ? elementRef.parentElement
            : elementRef;
    const offsetParent = element.offsetParent;

    if (element && offsetParent) {
        return (
            element.offsetTop < offsetParent.scrollTop ||
            element.offsetTop + element.clientHeight - offsetParent.scrollTop >
                offsetParent.clientHeight
        );
    }
    return null;
};

type Props = {
    items: any[];
    focusedItemIndex: number;
};
export const useScroll = ({items, focusedItemIndex}: Props) => {
    const prevFocusedIndex = useRef<number>();
    const itemsRef = useRef<Array<React.RefObject<HTMLDivElement> | null>>([]);
    // fill itemsRef array with refs according to items length
    itemsRef.current = Array(items.length)
        .fill(0)
        .map((_, i) => itemsRef.current[i] || React.createRef());

    useEffect(() => {
        if (focusedItemIndex !== prevFocusedIndex.current) {
            scrollSelectedItemIntoView(itemsRef.current[focusedItemIndex]);
            prevFocusedIndex.current = focusedItemIndex;
        }
    }, [focusedItemIndex]);

    return {itemsRef};
};
